import * as THREE from 'three';

export function generateRenderTarget(particleResolution) {

    const RT = new THREE.WebGLRenderTarget(
        particleResolution,
        particleResolution,
        {
        type: THREE.FloatType,           
        format: THREE.RGBAFormat,
        minFilter: THREE.NearestFilter,
        magFilter: THREE.NearestFilter,
        generateMipmaps: false,
        stencilBuffer: false,
        depthBuffer: false,
        });

    return RT;

}